import getTranslation from 'app/modules/shared/util/Language';

interface User {
    companyData?: {
        isCuttingEnabled?: boolean;
    };
    scope?: {
        garment?: boolean;
    };
}

const user_id = localStorage.getItem('user_id');
const user: User | null = user_id ? (JSON.parse(user_id) as User) : null;

export const supportedCurrencies = [
    {
        label: 'EGP - Egyptian Pound',
        value: 'EGP',
    },
    {
        label: 'USD - United States Dollar',
        value: 'USD',
    },
    {
        label: 'EUR - Euro',
        value: 'EUR',
    },
    {
        label: 'SAR - Saudi Riyal',
        value: 'SAR',
    },
    {
        label: 'CAD - Canadian Dollar',
        value: 'CAD',
    },
    {
        label: 'TRY - Turkish Lira',
        value: 'TRY',
    },
    {
        label: 'TND - Tunisian Dinar',
        value: 'TND',
    },
    {
        label: 'MAD - Moroccan Dirham',
        value: 'MAD',
    },
    {
        label: 'PKR - Pakistan Rupee',
        value: 'PKR',
    },
    {
        label: 'JOD - Jordanian Dinar',
        value: 'JOD',
    },
    {
        label: 'INR - Indian Rupee',
        value: 'INR',
    },
    {
        label: 'IDR - Indonesian Rupiah',
        value: 'IDR',
    },
    {
        label: 'RUB - Russian Ruble',
        value: 'RUB',
    },
    {
        label: 'FJD - Fiji Dollar',
        value: 'FJD',
    },
    {
        label: 'AUD - Australian Dollar',
        value: 'AUD',
    },
] as const;

export const attendanceTypeMethods = [
    {
        label: getTranslation('factory.attendanceTypeMethod.workingHours'),
        value: 'factoryWorkingHours',
    },
    {
        label: getTranslation('factory.attendanceTypeMethod.zkteco'),
        value: 'zkteco',
    },
] as const;
export const weekDays = [
    { label: 'saturday', value: 'Saturday' },
    { label: 'sunday', value: 'Sunday' },
    { label: 'monday', value: 'Monday' },
    { label: 'tuesday', value: 'Tuesday' },
    { label: 'wednesday', value: 'Wednesday' },
    { label: 'thursday', value: 'Thursday' },
    { label: 'friday', value: 'Friday' },
] as const;

export const deviceLanguages = [
    {
        label: 'العربية',
        value: 'AR',
        icon: 'sa',
        locale: 'ar',
    },
    {
        label: 'English',
        value: 'EN',
        icon: 'gb',
        locale: 'en',
    },
    {
        label: 'Française',
        value: 'FR',
        icon: 'fr',
        locale: 'fr',
    },
] as const;

export const supportedLanguages = [
    ...deviceLanguages,
    {
        label: 'Türkçe',
        value: 'TR',
        icon: 'tr',
        locale: 'tr',
    },
] as const;

export const availableEfficiencies = [
    {
        label: getTranslation('employeesEfficiency.labourEfficiency'),
        value: '0',
    },
    {
        label: getTranslation('employeesEfficiency.operationalEfficiency'),
        value: '1',
    },
] as const;

export const availableSalaryMethods = [
    {
        label: getTranslation('factory.salaryMethod.costPerDay'),
        value: 'daily',
    },
    {
        label: getTranslation('factory.salaryMethod.costPerHour'),
        value: 'hourly',
    },
] as const;

export const inspectionLevels = [
    { label: 'I', value: 'I' },
    { label: 'II', value: 'II' },
    { label: 'III', value: 'III' },
    { label: 'S1', value: 'S1' },
    { label: 'S2', value: 'S2' },
    { label: 'S3', value: 'S3' },
    { label: 'S4', value: 'S4' },
] as const;
export const majorDefects = [
    { label: '0', value: '0' },
    { label: '1', value: '1' },
    { label: '1.5', value: '1.5' },
    { label: '2.5', value: '2.5' },
    { label: '4', value: '4' },
    { label: '6.5', value: '6.5' },
    { label: '10', value: '10' },
] as const;

export const targetCalculationMethods = [
    {
        label: getTranslation('factory.targetCalculationMethod1'),
        value: '1',
    },
    {
        label: getTranslation('factory.targetCalculationMethod2'),
        value: '2',
    },
    {
        label: getTranslation('factory.targetCalculationMethod3'),
        value: '3',
    },
    {
        label: getTranslation('factory.targetCalculationMethod4'),
        value: '4',
    },
    {
        label: getTranslation('factory.targetCalculationMethod5'),
        value: '5',
    },
] as const;

export const durationToTurnRottenBatchesUnits = {
    hours: {
        default: '24',
        min: 1,
        max: 100,
    },
} as const;

export const efficiencyThresholdLevels = [
    {
        min: null,
        max: 65,
        color: '#e53935',
    },
    {
        min: 65,
        max: 85,
        color: '#fbc02d',
    },
    {
        min: 85,
        max: null,
        color: '#4caf50',
    },
] as const;

export const p2pColorLevels = [
    {
        min: null,
        max: 80,
        color: '#e53935',
    },
    {
        min: 80,
        max: 100,
        color: '#fbc02d',
    },
    {
        min: 100,
        max: null,
        color: '#4caf50',
    },
] as const;

export const tabs = [
    'general',
    'production',
    'quality',
    ...(user?.companyData?.isCuttingEnabled ? ['cutting'] : []),
    'planning',
    ...(user?.scope?.garment ? ['internalOnly'] : []),
] as const;

export const initialTabsValues = {
    generalTab: {
        name: '',
        factory_company_id: '',
        countryCode: '',
        timeZone: '',
        currency: '',
        address: '',
        attendanceType: '',
        primaryLanguage: '',
        secondaryLanguage: '',
        weekStart: '',
        timeZones: [],
    },
    productionTab: {
        deviceDefaultLanguage: '',
        targetCalculationMethod: '',
        shiftTolerance: '',
        checkOutVerificationToleranceInHours: '',
        missingProcessesThreshold: '',
        order_stoppage_threshold: '',
        allowOverrideLogin: false,
        batchGrouping: false,
        allowPieceTracking: false,
        isAutomateBeats: true,
        allowHomeSectionLoginOnly: false,
        allowOverrideAutomatedBeats: false,
        idleTime: true,
        idleTimeEfficiencyCalculation: false,
        mainEfficiency: '0',
        salaryMethod: 'daily',
        durationToTurnRottenBatches:
            durationToTurnRottenBatchesUnits.hours.default,
        efficiencyThresholdLevels: efficiencyThresholdLevels,
        p2pColorLevels: p2pColorLevels,
    },
    qualityTab: {
        inlineQualityIssuesThreshold: '',
        inlineQualityWarningThreshold: '',
        qualityStationGradedPiecesThreshold: '',
        qualityStationInRepairPiecesThreshold: '',
        isAQLEnabled: false,
        generalInspectionLevel: '',
        majorDefectsAQL: '',
        minorDefectsAQL: '',
    },
    cuttingTab: {
        isCuttingEnabled: false,
    },
    planningTab: {
        isNewOrderTarget: false,
    },
    internalOnlyTab: {
        allowPieceTracking: false,
        isNewOrderTarget:false,
        allowPacking:false,
        isQualityEnabled:false
    },
} as const;
